import { useAuth } from "../../../../context";
import { useQuery } from "react-query";
import { CategoriesCommon } from "../../../../api";

export const categoriesCommonKeys = {
  transportTypes: () => ["transportTypes"]
};

export function useGetTransportTypes(config) {
  const { callApi } = useAuth();
  return useQuery(categoriesCommonKeys.transportTypes(),
    () => callApi(CategoriesCommon.getTransportTypes), config);
}